import type { CSSProperties, HTMLAttributes } from 'react';
import { clsx } from 'clsx';
import styles from './skeleton.module.scss';

type SkeletonType = 'line' | 'rect' | 'round';

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  allowExpand?: boolean;
  charCount?: number;
  fillParent?: boolean;
  // lines is the number of lines to render if type is set to line. Defaults to 1.
  lines?: number;
  parentClassName?: string;
  parentStyle?: CSSProperties;
  type?: SkeletonType;
}

export function Skeleton({
  allowExpand,
  className,
  charCount,
  fillParent,
  lines = 1,
  parentClassName,
  parentStyle,
  style,
  type = 'line',
  ...rest
}: SkeletonProps) {
  return (
    <span
      aria-atomic
      aria-busy
      aria-hidden
      aria-live="polite"
      className={clsx(styles.skeleton, fillParent && styles.fillParent, parentClassName)}
      style={parentStyle}
    >
      {type === 'rect' || type === 'round' ? <div className={clsx(styles[`shape-${type}`], className)} style={style} {...rest} /> : null}
      {type === 'line' &&
        new Array(lines).fill(undefined).map((_, i) => (
          <span
            className={clsx(styles.line, allowExpand && styles.allowExpand, className)}
            key={i}
            style={{ width: charCount ? `${charCount}ch` : undefined, ...style }}
            {...rest}
          >
            &zwnj;
          </span>
        ))}
    </span>
  );
}
